module.exports = __webpack_public_path__ + "static/media/S3N4-4.6bd2d53d.svg";